import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=6f435778&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=6f435778&prod&lang=css"
import style1 from "./Notifications.vue?vue&type=style&index=1&id=6f435778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f435778",
  null
  
)

export default component.exports